import { useState } from "react";
import { useAuth } from "./authcontext";

function AdminIframe() {
  const { user } = useAuth();
  const [iframeLoading, setIframeLoading] = useState(true);

  //  Still waiting for session_id
  if (!user?.session_id) {
    return (
      <div className="loadingGif">
        <img src="/assets/img/icons/loadingBook.gif" alt="Loading..." />
      </div>
    );
  }

  const iframeUrl = `https://www.pressewebshop2.de/kundendaten/${user.session_id}/`;

  return (
    <div style={{ position: "relative" }}>
      
      {/* Iframe still loading */}
      {iframeLoading && (
        <div className="loadingGif">
          <img src="/assets/img/icons/loadingBook.gif" alt="Loading..." />
        </div>
      )}

      <iframe
        src={iframeUrl}
        title="Admin Panel"
        onLoad={() => setIframeLoading(false)}
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
          visibility: iframeLoading ? "hidden" : "visible",
        }}
      />
    </div>
  );
}

export default AdminIframe;

